import { checkStore, checkKey, checkReducer } from './checkers'
import createReducer from '../reducer'
import { registerEntities } from '../actions'

/**
 * creates injectReducer helper for provided store
 *
 * @param {Object} store - redux store
 * @param {Boolean} isValid - is store validated before to not check again
 * @return {Function} injectReducer helper
 */
export function injectReducerFactory(store, isValid) {
  /**
   * inject reducer on given store
   *
   * @param {String} key - store.injectedReducer key to identify
   * @param {Function} reducer - reducer function
   * @param {Object} options - to inject reducer
   * @param {Array<String>} [options.entities=[]] - entities names to register
   * @throws {InvariantError} if store, key, or reducer are invalid
   */
  return (key, reducer, { entities = [] } = {}) => {
    if (!isValid) checkStore(store)
    checkKey(key)
    checkReducer(reducer)

    // inject reducer if is not injected or has different implementation (hot-reload)
    if (
      !Reflect.has(store.injectedReducers, key) ||
      store.injectedReducers[key] !== reducer
    ) {
      store.injectedReducers[key] = reducer
      store.replaceReducer(createReducer(store.injectedReducers, store.history))

      if (entities.length > 0) {
        store.dispatch(registerEntities(entities))
      }
    }
  }
}

/**
 * create the injectReducer method for the given store
 *
 * @param {Object} store - redux store
 * @return {{ injectReducer: Function }} reducer injectors
 * @throws {InvariantError} if store is invalid
 */
export default function getInjectors(store) {
  checkStore(store)

  return {
    injectReducer: injectReducerFactory(store)
  }
}
